import {Scalars} from "@/store/modules/hds/Model";

/**
 * ID の詳細を表現する
 */
export default class IdInfo {
    /** ID の正規表現 */
    private static PARSER = /^([^:]+):(.+)$/

    /**
     * IdInfo を生成します
     *
     * @param id ID
     */
    public static of(id: Scalars['ID']): IdInfo {
        const m = IdInfo.PARSER.exec(id);
        if(m) {
            return new IdInfo(m[1], parseInt(m[2]));
        } else {
            throw new Error(`$id is not ID`);
        }
    }

    /** 要素ID */
    public readonly elementId: string;

    /** バージョン */
    public readonly version: number;

    /**
     * コンストラクタ
     *
     * @param elementId 要素ID
     * @param version バージョン
     * @private
     */
    private constructor(elementId: string, version: number) {
        this.elementId = elementId;
        this.version = version;
    }

    /**
     * 元の ID の文字列表現を取得します
     */
    public toString(): string {
        return `${this.elementId}:${this.version}`;
    }
}
